<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <card-component
        :title="formCardTitle"
        icon="file-edit"
        class="tile is-child"
      >
        <sales-add
          @handleAddSale="handleAddSale"
          @handleEditSale="handleEditSale"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import ElectronicRegisterSale from "@/services/electronicRegisterSalesOffer.service";
import { notify } from "@/helpers/notify";
import TitleBar from "@/components/TitleBar";
import CardComponent from "@/components/CardComponent";
import SalesAdd from "../components/sales/sales-add.vue";

export default {
  name: "Sale",
  components: { TitleBar, CardComponent, SalesAdd },
  data() {
    return {
      editMode: false,
    };
  },
  methods: {
    async handleAddSale(sale) {
      try {
        const { handleAddSale } = ElectronicRegisterSale;
        const response = await handleAddSale(sale);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Inregistrarea a fost adaugata.");
          this.$router.push({ path: "/Sales" });
        } else {
          notify.error(this, "Eroare la adaugarea inregistrarii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
    async handleEditSale(sale) {
      try {
        const { handleEditSale } = ElectronicRegisterSale;
        const response = await handleEditSale(sale);
        notify.success(this, "Inregistrarea a fost modificata.");
        this.$router.push({ path: "/Sales" });
      } catch (error) {
        notify.error(this, "Eroare la modificarea inregistrarii.");
      }
    },
  },
  computed: {
    titleStack() {
      const parent = { label: "Registru Evidenta Vanzare Terenuri Agricole Extravilan", to: "/Sales" };
      if (this.editMode) {
        return [parent, "Editare inregistrare"];
      } else {
        return [parent, "Adaugare inregistrare"];
      }
    },
    formCardTitle() {
      if (this.editMode) {
        return "Editare inregistrare";
      } else {
        return "Adaugare inregistrare";
      }
    },
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    if (id) {
      this.editMode = true;
    } else {
    }
  },
};
</script>
